import BaseClass from "../../libs/base/BaseClass";
import TouchEventClass from "../../libs/event/TouchEventClass";
import Util from "../../libs/util/Util";
import gsap from "gsap";

/**
 * スライダーのポインター部分
 */
export default class SliderPointerClass extends BaseClass{
    constructor(_target,_isPointA) {
        super();
        this.name = "SliderPointerClass";

        this.EVENT_CHANGE = "eventChange";

        this.target = _target;

        this.touchEvent = new TouchEventClass();
        this.onTouchStartListener = this.onTouchStart.bind(this);
        this.onTouchMoveListener = this.onTouchMove.bind(this);
        this.onTouchEndListener = this.onTouchEnd.bind(this);

        this.maxX = 100;
        this.sliderWidth = 100;
        this.nowPos = 0;
        this.nowPar = 0;

        this.pointWidth = 0;

        this.isPointA = _isPointA;
        this.otherPar = 1;
    }

    onCreate() {
        //TweenMax.set(this.target,{x:0});

        this.touchEvent.onCreate(this.target,true);
        this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_START,this.onTouchStartListener);
        this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_MOVE,this.onTouchMoveListener);
        this.touchEvent.bind(this.touchEvent.EVENT_TOUCH_END,this.onTouchEndListener);
        this.touchEvent.addEvent();
    }

    onResize(_size) {
        //console.log(_size);
        this.pointWidth = _size.pointWidth;
        this.sliderWidth = _size.w;
        if(!this.isPointA) this.sliderWidth *= -1;

        this.setMoveArea();
        //if(!this.isPointA) this.maxX *= -1;

        this.onSetPos(this.nowPar);
    }

    onReset(){
        this.nowPos = 0;
        this.nowPar = 0;
        this.otherPar = 1;
        this.setMoveArea();
        this.onSetPos(this.nowPar);
    }

    onOtherChange(_par){
        this.otherPar = _par;
        this.setMoveArea();
        //console.log(this.name,this.isPointA,"onOtherChange",_par);
    }

    onTouchStart(e,d){
        //console.log(this.name,"onTouchStart");
    }

    onTouchMove(e,d){
        //console.log(this.name,"onTouchMove");
        let touchVar = d.data;
        let event = d.event;
        let direction = Util.getDirection(Util.getAngle({x:touchVar.startX,y:touchVar.startY},{x:touchVar.endX,y:touchVar.endY}));

        if(Math.abs(touchVar.startY - touchVar.endY) > 150 || direction === 'up' || direction === 'down' ){
        } else {
            event.preventDefault();
            let x = touchVar.startX - touchVar.endX;
            let moveX = this.nowPos - x;
            if(this.isPointA){
                if(moveX < 0) moveX = 0;
                if(moveX > this.maxX) moveX = this.maxX;
            } else {
                if(moveX > 0) moveX = 0;
                if(moveX < this.maxX) moveX = this.maxX;
            }
            gsap.set(this.target,{x:moveX});
            touchVar.diff = touchVar.startX - touchVar.endX;
            this.onChange();
        }
    }

    onTouchEnd(e,d){
        this.nowPos = this.getNowX();
        this.onChange();
    }

    setDefault(_par){
        this.nowPar = (this.isPointA)? _par : 1 - _par;
        this.onSetPos(this.nowPar);
        this.jq.trigger(this.EVENT_CHANGE,{par:_par});
    }

    onSetPos(_par){
        let x = this.sliderWidth * _par;
        gsap.set(this.target,{x:x});
        this.nowPos = this.getNowX();
    }

    onChange(){
        const x = this.getNowX();
        const par = Math.abs(x) / Math.abs(this.sliderWidth);
        let sendPar = par;
        if(!this.isPointA) sendPar = 1 - par;
        this.jq.trigger(this.EVENT_CHANGE,{par:sendPar});
        this.nowPar = par;
    }

    setMoveArea(){
        this.maxX = this.sliderWidth * this.otherPar;
        if(this.isPointA) {
            this.maxX -= this.pointWidth;
        } else {
            this.maxX += this.pointWidth;
        }
        //console.log(this.maxX,this.pointWidth);
    }

    getNowX(){
        let nowPos = 0;
        if(this.target.css("transform") && this.target.css("transform") !== "none") {
            nowPos = parseFloat((Util.getTransfromValue(this.target.css("transform")))["transform-x"]);
        }
        return nowPos;
    }

}